const BAZI_TEXTS = {
  vi: {
    chip: 'Bazi · Ngũ Hành',
    title: 'Hệ Thống Phân Tích Tử Vi (Bazi)',
    subtitle: 'Phân tích Tứ Trụ, sức mạnh Ngũ Hành và dự đoán vận trình 6 năm tiếp theo.',
    meta: 'Thuật toán: Lập Xuân · Can-Chi · Ngũ Hành · Chi Relations',
    birthDateLabel: 'Ngày sinh (Dương lịch)',
    birthHourLabel: 'Giờ sinh',
    genderLabel: 'Giới tính',
    genderOptions: {
      male: 'Nam',
      female: 'Nữ'
    },
    timezoneLabel: 'Múi giờ',
    highlightTitle: 'Chuẩn hóa Tứ Trụ',
    highlightDesc: (timezoneLabel) => `Can–Chi ngày theo JDN, tháng theo 24 tiết khí (${timezoneLabel}), giờ theo Can ngày.`,
    tabsLabel: 'Chọn tab nội dung',
    tabs: {
      chart: '📊 Tứ Trụ',
      analysis: '⚡ Phân Tích',
      forecast: '📈 Dự Đoán 6 Năm',
      relations: 'ℹ️ Quan Hệ Chi',
      reading: '🔮 Tử Vi chi tiết'
    },
    invalidDate: 'Ngày sinh không hợp lệ, vui lòng nhập lại.',
    chartTitle: 'Tứ Trụ (Four Pillars)',
    pillars: {
      year: 'Năm Trụ',
      month: 'Tháng Trụ',
      day: 'Ngày Trụ',
      hour: 'Giờ Trụ'
    },
    branchLabel: 'Chi',
    dayMasterLabel: 'Chủ Can (Day Master):',
    analysisTitle: 'Phân Tích Mệnh Cục',
    constitutionLabel: 'Tính Chất',
    relativeStrengthLabel: 'Sức Mạnh Tương Đối',
    dayMasterElementLabel: 'Yếu Tố Chủ Can',
    elementStrengthLabel: 'Sức mạnh Ngũ Hành',
    fiveElementsMethodLabel: 'Cách tính Ngũ Hành',
    fiveElementsMethod: ({ method, details } = {}) => {
      if (method === 'tang_can_weighted') {
        const weights = details?.tangCanWeights?.join(' / ') || '0.6 / 0.3 / 0.1';
        const bonus = details?.monthBranchBonus ?? 0.5;
        return `Cách tính: 8 chữ + tàng can (${weights}) + đương lệnh (+${bonus}).`;
      }
      return 'Cách tính: 8 chữ (không tàng can).';
    },
    recommendationLabel: 'Khuyến nghị',
    reasoningTitle: 'Chi tiết phân tích',
    reasoningEmpty: 'Chưa có nhận định nổi bật.',
    reasoning: {
      health: 'Sức khỏe',
      career: 'Sự nghiệp',
      wealth: 'Tài vận'
    },
    forecastTitle: 'Dự Đoán 6 Năm Tiếp Theo',
    branchRelationLabel: 'Chi:',
    outlookLabel: 'Triển vọng',
    relationTitle: 'Chi Relations - Quan Hệ Địa Chi',
    forecastRelations: {
      compatible: 'Hợp 👫',
      clash: 'Xung ⚡',
      harm: 'Hại 💔',
      break: 'Phá 💥',
      independent: 'Độc Lập'
    },
    forecastOutlooks: {
      positive: 'Tích cực 🌟',
      caution: 'Cần cẩn thận ⚠️',
      neutral: 'Bình thường'
    },
    detailedReadingTitle: 'Bản luận Tử Vi chi tiết'
    ,
    detailedReading: {
      dataset: {
        label: 'Bảng JSON Tử Vi chi tiết',
        help: 'Dùng để đối chiếu toàn bộ nội dung luận giải khi tích hợp dự án hoặc kiểm thử.',
        copyCta: 'Copy JSON',
        copied: 'Đã copy JSON chi tiết.',
        failed: 'Trình duyệt không cho copy, hãy copy thủ công.'
      },
      intro: {
        birthDate: (label) => `📅 Sinh ngày ${label} (dương lịch)`,
        lunarDate: (label, dayCanChi, monthCanChi, yearCanChi) => {
          const hasCanChi = dayCanChi || monthCanChi || yearCanChi;
          const canChiLine = hasCanChi
            ? ` · Can Chi: ${dayCanChi || '—'} / ${monthCanChi || '—'} / ${yearCanChi || '—'}`
            : '';
          return `🌙 Âm lịch: ${label}${canChiLine}`;
        },
        birthHour: (label) => `⏰ Giờ sinh: ${label}`,
        age: (yearLabel, age) => `🎂 Tuổi: ${yearLabel}${age !== null ? ` · ${age} tuổi` : ''}`
      },
      sections: {
        pillars: {
          title: '1️⃣ Lập lá số Tứ Trụ',
          description: 'Thông tin được cá nhân hóa theo ngày giờ sinh bạn nhập, làm cơ sở cho mệnh cục – dụng thần – đại vận – sự nghiệp – tài vận – hôn nhân – hậu vận.',
          blocks: {
            year: '🔹 Trụ Năm',
            month: '🔹 Trụ Tháng',
            day: '🔹 Trụ Ngày (MỆNH CHỦ)',
            hour: '🔹 Trụ Giờ'
          },
          elementLine: (element) => `→ Ngũ hành: ${element}`,
          dayMasterLine: (dayMaster, element) => `* Nhật chủ: ${dayMaster} (${element})`,
          dayBranchLine: (element) => `* Chi ngày: ${element}`,
          summary: {
            year: (label, element) => `Năm: ${label} (${element})`,
            month: (label, element) => `Tháng: ${label} (${element})`,
            day: (label, element) => `Ngày: ${label} (${element}) ← Nhật chủ`,
            hour: (label, element) => `Giờ: ${label} (${element})`
          }
        },
        balance: {
          title: '2️⃣ Cân bằng Ngũ Hành (Cực kỳ quan trọng)',
          tableHeaders: ['Ngũ hành', 'Mức độ'],
          dominant: (label) => `👉 Ngũ hành vượng nhất: ${label}.`,
          weakest: (label) => `👉 Ngũ hành yếu nhất: ${label}.`
        },
        harmony: {
          title: '3️⃣ Dụng thần – Hỷ thần – Kỵ thần (theo rule)',
          blocks: {
            controllerLabel: (label) => `✅ DỤNG THẦN (ưu tiên điều tiết): ${label}`,
            controllerBody: {
              first: (constitution) => `Mệnh hiện tại: ${constitution}.`,
              second: (controller, dayMaster) => `Dụng thần ưu tiên ${controller} để điều tiết và cân bằng nhật chủ ${dayMaster}.`,
              reasoning: (details) => `Căn cứ: ${details}.`
            },
            generatorLabel: (label) => `✅ HỶ THẦN (hỗ trợ): ${label}`,
            generatorBody: {
              first: (generator) => `${generator} hỗ trợ điều hòa tổng thể, giúp mệnh cục linh hoạt hơn.`,
              second: (generator) => `Ưu tiên môi trường, màu sắc, ngành nghề có yếu tố ${generator} để cân bằng.`
            },
            tabooLabel: '⚠️ KỴ THẦN'
          },
          taboo: {
            reduceSelf: {
              first: (dayMaster) => `Hạn chế tăng thêm ${dayMaster} để tránh quá vượng.`,
              second: (generator, dayMaster) => `Tiết chế yếu tố ${generator} vì dễ làm ${dayMaster} mạnh hơn.`
            },
            nourishSelf: {
              first: (controller) => `Tránh để ${controller} lấn át quá mạnh.`,
              second: (generator, dayMaster) => `Duy trì bổ sung ${generator} để nâng nền tảng ${dayMaster}.`
            },
            default: {
              first: 'Giữ cân bằng các yếu tố, tránh cực đoan một ngũ hành.',
              second: 'Ưu tiên nhịp sinh hoạt ổn định để cân bằng tổng thể.'
            }
          }
        },
        personality: {
          title: '4️⃣ Luận tính cách & nội tâm',
          paragraphs: {
            first: (dayMaster, element) => `Nhật chủ ${dayMaster} (${element}) thường có chính kiến, chủ động và thiên về trách nhiệm.`,
            second: (dominant) => `Ngũ hành vượng ${dominant} tạo xu hướng ổn định, chịu trách nhiệm và bền bỉ trong các lĩnh vực liên quan.`,
            third: (weak) => `Ngũ hành yếu ${weak} cần được bồi bổ để cân bằng cảm xúc và sức bền.`,
            fourth: 'Nếu biết cân bằng, càng trưởng thành càng dễ có uy tín và vị thế.'
          }
        },
        career: {
          title: '5️⃣ Sự nghiệp – Công danh',
          summary: '👉 Thành công đến muộn nhưng chắc, hợp chiến lược dài hạn.',
          blocks: {
            fitLabel: '🌱 RẤT HỢP',
            fit: [
              'Quản lý – điều hành – lãnh đạo',
              'CNTT / hạ tầng / hệ thống (vai trò quản trị, kiến trúc)',
              'Giáo dục – đào tạo – cố vấn',
              'Bất động sản – dự án dài hạn',
              'Phân tích – tài chính – đầu tư giá trị'
            ],
            avoidLabel: '⚠️ KHÔNG HỢP',
            avoid: [
              'Lướt sóng ngắn hạn',
              'Nghề nhiều xung đột, thay đổi liên tục',
              'Làm việc thiếu kỷ luật hoặc không có lộ trình'
            ]
          }
        },
        careerClusters: {
          title: '5️⃣.1 Cụm nghề nghiệp theo Ngũ hành trội',
          description: (dominant) => `Dựa vào ngũ hành vượng (${dominant}), các cụm nghề phù hợp gồm:`
        },
        wealth: {
          title: '6️⃣ Tài vận',
          paragraphs: [
            'Không giàu sớm nhưng tích lũy tốt nếu giữ kỷ luật tài chính.',
            'Ưu tiên tài sản bền vững, tránh đòn bẩy cao.',
            'Đỉnh tài vận thường đến khi ổn định nền tảng nghề nghiệp.'
          ]
        },
        family: {
          title: '7️⃣ Hôn nhân – Gia đạo',
          paragraphs: [
            'Tình cảm sâu, ít nói ra, dễ nhường.',
            'Cần giao tiếp thẳng thắn, tránh ôm hết trách nhiệm.',
            'Khi cân bằng được công việc và gia đình, gia đạo bền vững.'
          ]
        },
        health: {
          title: '8️⃣ Sức khỏe theo Bát Tự',
          paragraphs: {
            first: (weak) => `Ngũ hành yếu (${weak}) dễ gây mất cân bằng thể lực.`,
            second: 'Ưu tiên ngủ sớm, vận động nhẹ, ăn uống thanh đạm.',
            third: 'Duy trì nhịp sinh hoạt ổn định để giảm stress.'
          }
        },
        destiny: {
          title: '9️⃣ Đại vận (tóm tắt trục đời)',
          tableHeaders: ['Tuổi', 'Vận'],
          meta: {
            direction: {
              thuan: 'Chiều thuận',
              nghich: 'Chiều nghịch'
            },
            directionRule: 'Nam + Can năm dương ⇒ Thuận; Nam + Can năm âm ⇒ Nghịch; Nữ thì ngược lại.',
            startAge: (age) => `Tuổi khởi vận: ${age} (khoảng cách tới tiết khí gần nhất ÷ 3).`,
            startRule: 'Làm tròn chẵn/lẻ theo chiều thuận/nghịch, khởi tính từ tiết khí gần nhất.',
            warning: (warnings) => `⚠️ Cảnh báo đại vận: ${warnings.join(', ')}.`,
            missing: 'Chưa có dữ liệu đại vận từ engine.'
          }
        },
        decades: {
          title: '📈 Đại vận chi tiết từng 10 năm',
          tableHeaders: ['Giai đoạn (năm dương lịch)', 'Xu hướng chính']
        },
        yearly: {
          title: '📅 Vận năm 2025–2035',
          paragraphs: {
            first: 'Giai đoạn này thiên về củng cố vị thế, ưu tiên ổn định – tích lũy.',
            second: (controller, generator) => `Các năm có hành ${controller} hoặc ${generator} thường thuận lợi hơn.`,
            third: 'Các nhãn tác động mang tính tương đối, cần xét tổng thể mệnh cục.',
            fourth: 'Ghi chú: nhãn Ngũ hành đang lấy theo Thiên Can của năm để đơn giản hóa.'
          },
          tableHeaders: ['Năm', 'Can Chi', 'Ngũ hành', 'Tổng quan']
        },
        investment: {
          title: '💼 Đầu tư – tài chính – cổ phiếu – BĐS theo mệnh',
          summary: '👉 Tư duy “bền – chắc – dài hạn” là chìa khóa.',
          blocks: {
            fitLabel: '✅ Phù hợp',
            fit: [
              'Đầu tư giá trị, giữ dài hạn',
              'Bất động sản có dòng tiền ổn',
              'Cổ phiếu cơ bản, tài chính an toàn'
            ],
            avoidLabel: '⚠️ Nên tránh',
            avoid: [
              'Lướt sóng ngắn hạn',
              'Đòn bẩy cao, vay nóng',
              'Danh mục quá phân tán, thiếu kỷ luật'
            ]
          }
        },
        familyDeep: {
          title: '❤️ Hôn nhân – gia đạo sâu hơn',
          paragraphs: [
            'Bạn có xu hướng yêu sâu, ít bộc lộ. Điều này tạo cảm giác an toàn nhưng dễ khiến đối phương thấy khoảng cách.',
            'Chia sẻ cảm xúc đều đặn giúp giảm áp lực, tăng sự đồng hành.',
            'Giai đoạn 46–55 là lúc gia đạo ổn định nhất nếu biết đặt ưu tiên gia đình song hành sự nghiệp.'
          ]
        },
        conclusion: {
          title: '🔮 Kết luận cuối',
          paragraphs: [
            'Lá số thiên về ổn định và hậu phát.',
            'Không sợ chậm, chỉ sợ đứng yên.',
            'Càng về sau càng vững – càng có uy.'
          ]
        }
      }
    }
  },
  en: {
    chip: 'Bazi · Five Elements',
    title: 'Bazi Astrology Analyzer',
    subtitle: 'Analyze Four Pillars, Five Element strengths, and forecast the next 6 years.',
    meta: 'Algorithms: Li Chun · Heavenly Stems & Branches · Five Elements · Branch relations',
    birthDateLabel: 'Birth date (Solar)',
    birthHourLabel: 'Birth hour',
    genderLabel: 'Gender',
    genderOptions: {
      male: 'Male',
      female: 'Female'
    },
    timezoneLabel: 'Timezone',
    highlightTitle: 'Four Pillars normalization',
    highlightDesc: (timezoneLabel) => `Day pillar via JDN, month via 24 solar terms (${timezoneLabel}), hour via day stem.`,
    tabsLabel: 'Select analysis tab',
    tabs: {
      chart: '📊 Four Pillars',
      analysis: '⚡ Analysis',
      forecast: '📈 6-Year Forecast',
      relations: 'ℹ️ Branch Relations',
      reading: '🔮 Detailed Reading'
    },
    invalidDate: 'Invalid birth date, please re-enter.',
    chartTitle: 'Four Pillars',
    pillars: {
      year: 'Year Pillar',
      month: 'Month Pillar',
      day: 'Day Pillar',
      hour: 'Hour Pillar'
    },
    branchLabel: 'Branch',
    dayMasterLabel: 'Day Master:',
    analysisTitle: 'Fate Pattern Analysis',
    constitutionLabel: 'Constitution',
    relativeStrengthLabel: 'Relative Strength',
    dayMasterElementLabel: 'Day Master Element',
    elementStrengthLabel: 'Five Element power',
    fiveElementsMethodLabel: 'Five Element method',
    fiveElementsMethod: ({ method, details } = {}) => {
      if (method === 'tang_can_weighted') {
        const weights = details?.tangCanWeights?.join(' / ') || '0.6 / 0.3 / 0.1';
        const bonus = details?.monthBranchBonus ?? 0.5;
        return `Method: 8 characters + hidden stems (${weights}) + month bonus (+${bonus}).`;
      }
      return 'Method: 8 characters only (no hidden stems).';
    },
    recommendationLabel: 'Recommendation',
    reasoningTitle: 'Analysis reasoning',
    reasoningEmpty: 'No standout indicators yet.',
    reasoning: {
      health: 'Health',
      career: 'Career',
      wealth: 'Wealth'
    },
    forecastTitle: '6-Year Outlook',
    branchRelationLabel: 'Branch relation:',
    outlookLabel: 'Outlook',
    relationTitle: 'Branch Relationships',
    forecastRelations: {
      compatible: 'Compatible 👫',
      clash: 'Clash ⚡',
      harm: 'Harm 💔',
      break: 'Disruptive 💥',
      independent: 'Independent'
    },
    forecastOutlooks: {
      positive: 'Positive 🌟',
      caution: 'Use caution ⚠️',
      neutral: 'Neutral'
    },
    detailedReadingTitle: 'Detailed Bazi Reading',
    detailedReading: {
      dataset: {
        label: 'Full detailed-reading JSON',
        help: 'Use to cross-check the entire deterministic report when integrating with other projects.',
        copyCta: 'Copy JSON',
        copied: 'Copied detailed JSON.',
        failed: 'Clipboard blocked, please copy manually.'
      },
      intro: {
        birthDate: (label) => `📅 Birth date ${label} (solar)`,
        lunarDate: (label, dayCanChi, monthCanChi, yearCanChi) => {
          const hasCanChi = dayCanChi || monthCanChi || yearCanChi;
          const canChiLine = hasCanChi
            ? ` · Stem-Branch: ${dayCanChi || '—'} / ${monthCanChi || '—'} / ${yearCanChi || '—'}`
            : '';
          return `🌙 Lunar date: ${label}${canChiLine}`;
        },
        birthHour: (label) => `⏰ Birth hour: ${label}`,
        age: (yearLabel, age) => `🎂 Age: ${yearLabel}${age !== null ? ` · ${age} years` : ''}`
      },
      sections: {
        pillars: {
          title: '1️⃣ Four Pillars Setup',
          description: 'Personalized data based on your birth details as the foundation for fate pattern, favorable elements, major cycles, career, wealth, marriage, and later life.',
          blocks: {
            year: '🔹 Year Pillar',
            month: '🔹 Month Pillar',
            day: '🔹 Day Pillar (Day Master)',
            hour: '🔹 Hour Pillar'
          },
          elementLine: (element) => `→ Element: ${element}`,
          dayMasterLine: (dayMaster, element) => `* Day Master: ${dayMaster} (${element})`,
          dayBranchLine: (element) => `* Day Branch: ${element}`,
          summary: {
            year: (label, element) => `Year: ${label} (${element})`,
            month: (label, element) => `Month: ${label} (${element})`,
            day: (label, element) => `Day: ${label} (${element}) ← Day Master`,
            hour: (label, element) => `Hour: ${label} (${element})`
          }
        },
        balance: {
          title: '2️⃣ Five Element Balance (Key)',
          tableHeaders: ['Element', 'Level'],
          dominant: (label) => `👉 Strongest element: ${label}.`,
          weakest: (label) => `👉 Weakest element: ${label}.`
        },
        harmony: {
          title: '3️⃣ Favorable – Supportive – Caution Elements',
          blocks: {
            controllerLabel: (label) => `✅ Favorable (balance): ${label}`,
            controllerBody: {
              first: (constitution) => `Current pattern: ${constitution}.`,
              second: (controller, dayMaster) => `Favorable element prioritizes ${controller} to balance ${dayMaster}.`,
              reasoning: (details) => `Basis: ${details}.`
            },
            generatorLabel: (label) => `✅ Supportive: ${label}`,
            generatorBody: {
              first: (generator) => `${generator} supports overall balance and flexibility.`,
              second: (generator) => `Prioritize environments, colors, or careers with ${generator} to stabilize the chart.`
            },
            tabooLabel: '⚠️ Caution'
          },
          taboo: {
            reduceSelf: {
              first: (dayMaster) => `Avoid adding too much ${dayMaster} to prevent excess.`,
              second: (generator, dayMaster) => `Limit ${generator} because it can strengthen ${dayMaster} further.`
            },
            nourishSelf: {
              first: (controller) => `Avoid letting ${controller} overpower too much.`,
              second: (generator, dayMaster) => `Keep reinforcing ${generator} to support ${dayMaster}.`
            },
            default: {
              first: 'Maintain balance across elements, avoid extremes.',
              second: 'Keep steady routines to balance the overall pattern.'
            }
          }
        },
        personality: {
          title: '4️⃣ Personality & Inner Traits',
          paragraphs: {
            first: (dayMaster, element) => `${dayMaster} (${element}) is often proactive, opinionated, and responsible.`,
            second: (dominant) => `Dominant ${dominant} supports strong action in related areas.`,
            third: (weak) => `Weak ${weak} should be nourished to stabilize emotions and stamina.`,
            fourth: 'With balance, maturity brings more influence and credibility.'
          }
        },
        career: {
          title: '5️⃣ Career – Achievement',
          summary: '👉 Success comes later but remains steady with long-term strategy.',
          blocks: {
            fitLabel: '🌱 Best fit',
            fit: [
              'Management – operations – leadership',
              'IT infrastructure / systems (admin, architecture)',
              'Education – training – mentoring',
              'Real estate – long-term projects',
              'Analytics – finance – value investing'
            ],
            avoidLabel: '⚠️ Avoid',
            avoid: [
              'Short-term speculation',
              'High-conflict, constantly changing jobs',
              'Work without discipline or roadmap'
            ]
          }
        },
        careerClusters: {
          title: '5️⃣.1 Career clusters by dominant element',
          description: (dominant) => `Based on the dominant element (${dominant}), recommended career clusters include:`
        },
        wealth: {
          title: '6️⃣ Wealth',
          paragraphs: [
            'Not rich early, but accumulates well with financial discipline.',
            'Favor durable assets, avoid heavy leverage.',
            'Wealth tends to peak after career foundations stabilize.'
          ]
        },
        family: {
          title: '7️⃣ Marriage – Family',
          paragraphs: [
            'Deep feelings, less expressive, often yielding.',
            'Communicate directly, avoid taking on all responsibility.',
            'When work and family balance, home life is stable.'
          ]
        },
        health: {
          title: '8️⃣ Health (Bazi)',
          paragraphs: {
            first: (weak) => `Weak ${weak} may reduce physical balance.`,
            second: 'Sleep early, light exercise, and a clean diet.',
            third: 'Maintain a stable routine to reduce stress.'
          }
        },
        destiny: {
          title: '9️⃣ Major cycles (summary)',
          tableHeaders: ['Age', 'Phase'],
          meta: {
            direction: {
              thuan: 'Forward direction',
              nghich: 'Reverse direction'
            },
            directionRule: 'Male + Yang year stem ⇒ Forward; Male + Yin year stem ⇒ Backward; Female is the reverse.',
            startAge: (age) => `Start age: ${age} (distance to nearest solar term ÷ 3).`,
            startRule: 'Rounded to odd/even based on forward/reverse direction, counting from the nearest solar term.',
            warning: (warnings) => `⚠️ Luck-cycle warnings: ${warnings.join(', ')}.`,
            missing: 'Major cycle data not available from engine yet.'
          }
        },
        decades: {
          title: '📈 10-year cycles (detail)',
          tableHeaders: ['Phase (solar years)', 'Main trend']
        },
        yearly: {
          title: '📅 Yearly outlook 2025–2035',
          paragraphs: {
            first: 'This phase focuses on strengthening position and steady accumulation.',
            second: (controller, generator) => `Years with ${controller} or ${generator} tend to be smoother.`,
            third: 'These labels are relative; outcomes depend on the overall chart.',
            fourth: 'Note: element labels are based on the year stem for simplicity.'
          },
          tableHeaders: ['Year', 'Pillar', 'Element', 'Overview']
        },
        investment: {
          title: '💼 Investment – finance – stocks – real estate',
          summary: '👉 A “steady – solid – long-term” mindset is key.',
          blocks: {
            fitLabel: '✅ Suitable',
            fit: [
              'Value investing, long holding periods',
              'Cash-flow real estate',
              'Blue-chip equities, safer finance'
            ],
            avoidLabel: '⚠️ Avoid',
            avoid: [
              'Short-term trading',
              'High leverage or hot loans',
              'Over-diversified portfolios without discipline'
            ]
          }
        },
        familyDeep: {
          title: '❤️ Deeper marriage & family',
          paragraphs: [
            'You tend to love deeply but show less. This can feel safe yet distant to partners.',
            'Sharing emotions regularly reduces pressure and builds companionship.',
            'Ages 46–55 are often the most stable for family if priorities are aligned.'
          ]
        },
        conclusion: {
          title: '🔮 Final takeaway',
          paragraphs: [
            'The chart favors stability and late blooming.',
            'Do not fear slow progress—only stagnation.',
            'Later years grow stronger and more respected.'
          ]
        }
      }
    }
  }
};

export default BAZI_TEXTS;
